import React from 'react';
import { Shield, Heart, MapPin, Clock } from 'lucide-react';

const badges = [
  { icon: Shield, label: 'Privacy-conscious', desc: 'Privacy controls that put you in control.' },
  { icon: Heart, label: 'Meaningful connections', desc: 'Conversation starts after mutual interest.' },
  { icon: MapPin, label: 'Built for Bihar & Jharkhand', desc: 'A focused community, not an impersonal directory.' },
  { icon: Clock, label: 'Take it at your pace', desc: 'Move forward when you\'re ready.' },
];

export default function TrustBadges({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <div className="flex items-center justify-center gap-4 flex-wrap">
        {badges.slice(0, 3).map((badge) => (
          <div key={`trust-compact-${badge.label}`} className="flex items-center gap-1.5">
            <badge.icon size={13} className="text-primary flex-shrink-0" />
            <span className="text-xs text-muted-foreground font-medium">{badge.label}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-widest mb-1">Why SAATH</p>
      {badges.map((badge) => (
        <div key={`trust-full-${badge.label}`} className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-white border border-border flex items-center justify-center shadow-sm flex-shrink-0">
            <badge.icon size={15} className="text-primary" />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">{badge.label}</p>
            <p className="text-xs text-muted-foreground">{badge.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}